import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { useLocation } from "react-router-dom";

import { getTourSteps } from "../Utils/getTourSteps";
import { postmortemSectionTourSteps } from "../constants/tourSteps";
const TourContext = createContext({});

export const AppTourProvider = ({ children }) => {
  const location = useLocation();

  const [currentTouringPage, setCurrentTouringPage] = useState(
    location.pathname
  );
  const [selectedId, setSelectedId] = useState();

  const [currentTouringSteps, setCurrentTouringSteps] = useState(
    getTourSteps()
  );
  const [refreshTouringSteps, setRefreshTouringSteps] = useState(false);
  const [currentPostmortemSection, setCurrentPostmorteSection] = useState(0);

  const [currentSection, setCurrentSection] = useState("");

  useEffect(() => {
    const getSteps = () => {
      const newPage = location.pathname;
      setCurrentTouringPage(newPage);
      const newSteps = getTourSteps(newPage, {
        tourStepsforPostmortemSection: currentPostmortemSection,
      });
      setCurrentTouringSteps(newSteps);
    };

    getSteps();
  }, [location.pathname]);

  useEffect(() => {
    if(currentSection)
    setCurrentTouringSteps(postmortemSectionTourSteps[currentSection]);
  }, [currentSection]);

  const handleTourStepsForPostmortemSection = useCallback((section) => {
    if(section)
    setCurrentSection(section);
  }, []);

  const contextValue = useMemo(
    () => ({
      setCurrentTouringPage,
      refreshTouringSteps,
      setRefreshTouringSteps,
      selectedId,
      setSelectedId,
      currentTouringSteps,
      setCurrentTouringSteps,
      handleTourStepsForPostmortemSection,
    }),
    [refreshTouringSteps, selectedId, currentTouringSteps, handleTourStepsForPostmortemSection]
  );

  return (
    <TourContext.Provider value={contextValue}>
      {children}
    </TourContext.Provider>
  );
};

export default function UseTourContext() {
  return useContext(TourContext);
}
